import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ChatRoute from './Data/ChatRoute'; 

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/:channelId" element={<ChatRoute />} />
    </Routes>
  </BrowserRouter>
);

reportWebVitals();


